import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pageRequest, onChangeField } from 'actions/openPlatform/appLearnMore';
import { PageWrapper } from 'components/wrappers/pages';
import { formValueSelector } from 'redux-form';
import { push } from 'react-router-redux';
import * as marketplaceUtil from 'utils/marketplace';
import * as clevertapOpenPlatformAppLearnMore from 'clevertap/openPlatform/appLearnMore';
import withFeatureFlags from 'hocs/withFeatureFlags';
import moment from 'moment';
import { refreshSession, getTokenExpiry } from 'utils/auth';
import Carousel from '../Carousel';
import Breadcrumb from '../Breadcrumb';
import Logo from '../Logo';
import Title from '../Title';
import ActionBar from '../ActionBar';
import styles from './AppLearnMore.css';

const InformationRow = ({ label, value }) => {
  const valueStyle = {};

  return (
    <div className={styles.infoRow}>
      <div className={styles.informationRow}>
        <label className={styles.titleLabel}>{label}</label>
        <label className={styles.valueLabel} style={valueStyle}>
          {value}
        </label>
      </div>
    </div>
  );
};

class Description extends React.PureComponent {
  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <div>
            <p style={{ marginBottom: '0' }}>{this.props.description_data}</p>
          </div>
        </div>
      </div>
    );
  }
}

class AppLearnMore extends Component {
  componentDidMount() {
    this.props.dispatch(pageRequest({ id: this.props.params.id }));
  }

  render() {
    if (this.props.app) {
      const { app } = this.props;

      return (
        <PageWrapper>
          <ActionBar
            location={this.props.location}
            onChangeField={this._onChangeField}
            fields={['keyword']}
            forceHighlight
          />
          <Breadcrumb
            locations={[AppLearnMore.capitalizedText(app.category), app.name]}
            onClickBreadcrumb={this._onClickBreadcrumb}
          />
          <div className={`container-fluid ${styles.customContainer}`}>
            <div className={`row col-sm-8 ${styles.topDescriptionContainer}`}>
              <div className="title-container">
                <Logo
                  src={app.logo.url || 'http://via.placeholder.com/350x350'}
                  style={{ float: 'left' }}
                />
                <div className={styles.textContainer}>
                  <h3 className="title-learn-more">{app.name}</h3>
                  <p>{app.short_description}</p>
                </div>
              </div>
              <div className="clearfix" />
            </div>
            <div className={`col-sm-8 ${styles.customContainer}`}>
              <div className={styles.carouselContainer}>
                <Carousel
                  images={app.oauth_application_images.map(
                    curImg => curImg.image.url
                  )}
                  wrapperClassName={styles.carouselWrapper}
                />
              </div>
              <div className={styles.descriptionContainer}>
                <Title title="Description" titleSize="18px" />
                <Description description_data={app.description} />
              </div>
            </div>
            <div className={styles.topDescriptionContainer} />
            <div
              className={`col-sm-4 ${styles.informationContainer} ${styles.carouselContainer}`}
            >
              <Title title="Information" titleSize="18px" />
              <InformationRow
                label="Pricing"
                value={AppLearnMore.displayText(app.price)}
              />
              <InformationRow
                label="Website"
                value={
                  <a href={`${app.website}`} target="_blank">
                    {app.website}
                  </a>
                }
              />
              <InformationRow label="Email" value={app.support_email} />
              <InformationRow
                label="Phone"
                value={AppLearnMore.displayText(app.support_phone)}
              />
              <button
                className={
                  app.is_authorized
                    ? `btn btn-default ${styles.getStartedBtn}`
                    : `btn btn-primary ${styles.getStartedBtn}`
                }
                onClick={this._onClickLaunch}
              >
                {app.is_authorized ? 'Manage App' : 'Get Started'}
              </button>
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <img
                  style={{ position: 'relative', top: '-1px', marginRight: 13 }}
                  src={require('assets/images/question-tooltip.svg')}
                />
                <a href="https://mokaposhelp.zendesk.com/hc/id/sections/360006230194-Moka-Connect">
                  Find out how this integration works?
                </a>
              </div>
            </div>
          </div>
        </PageWrapper>
      );
    }
    return <div />;
  }

  isSessionExpiredInTenMinutes = () => {
    return moment(getTokenExpiry()).diff(moment(), 'minute') <= 10;
  };

  _openNewWindow = app => {
    const { enableCmpLogin } = this.props;

    const url = enableCmpLogin
      ? marketplaceUtil.generateCMPExternalURL(app)
      : marketplaceUtil.generateExternalURL(app);
    window.open(url, '_blank');
  };

  _openExternalAppURL = app => {
    const { enableCmpLogin } = this.props;

    if (enableCmpLogin && this.isSessionExpiredInTenMinutes()) {
      refreshSession().then(() => this._openNewWindow(app));
    } else {
      this._openNewWindow(app);
    }
  };

  _onClickBreadcrumb = () => {
    const { app } = this.props;
    clevertapOpenPlatformAppLearnMore.appLearnMoreCategoryBreadcrumb({
      uid: app.uid,
      name: app.name,
      categoryName: app.category,
    });
  };

  _onClickLaunch = () => {
    const { app } = this.props;
    if (app.is_authorized) {
      this.props.dispatch(push('/apps/my-app'));
    } else {
      clevertapOpenPlatformAppLearnMore.appLearnMoreGetStarted({
        uid: app.uid,
        name: app.name,
      });
      this._openExternalAppURL(this.props.app);
    }
  };

  _onChangeField = ({ field, value }) => {
    const { searchValues, dispatch } = this.props;
    searchValues[field] = value;
    dispatch(onChangeField({ field, value, searchValues }));
  };

  static capitalizedText(str) {
    if (str !== undefined && str !== '') {
      str = str.charAt(0).toUpperCase() + str.slice(1);
      return str.replace(/_/g, ' ');
    }
    return 'Uncategorized';
  }

  static displayText(text) {
    if (text === null || text === '') {
      return '-';
    }
    return text;
  }
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const { app } = state.openPlatform.appLearnMore;
  return {
    app,
    searchValues: {
      keyword: selector(state, 'keyword'),
      category: selector(state, 'category'),
    },
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}
const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppLearnMore);

function mapFlagsToProps(flags) {
  return {
    enableCmpLogin: flags.enableCmpLogin,
  };
}

export default withFeatureFlags(mapFlagsToProps)(connected);
